import { render, staticRenderFns } from "./AgeVerification.vue?vue&type=template&id=cfb0cdcc&scoped=true"
import script from "./AgeVerification.vue?vue&type=script&lang=js"
export * from "./AgeVerification.vue?vue&type=script&lang=js"
import style0 from "./AgeVerification.vue?vue&type=style&index=0&id=cfb0cdcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb0cdcc",
  null
  
)

export default component.exports